import { Underwriting } from 'modules/cm/domain/Underwriting/Underwriting';

const data: Underwriting = {
  affordability: {
    maximumLoanPossible: null,
    disposableIncome: null,
    disposableIncomeBuffer: null,
    stage: null,
    livingCosts: null,
    netCashflow: null,
  },
  approvals: {
    approvedBy: null,
    approvedDate: null,
    initialAssessmentBy: null,
    initialAssessmentDate: null,
  },
  assets: {
    applicant1: [
      {
        type: null,
        value: null,
        description: null,
      },
    ],
    applicant2: [],
  },
  borrower: {
    applicant1: {
      age: null,
      employmentStatus: null,
      firstName: null,
      gender: null,
      lastName: null,
      maritalStatus: null,
      nationality: null,
      plannedRetirementAge: null,
      powerOfAttorneyFullName: null,
      proofOfAddress: null,
      proofOfId: null,
    },
    applicant2: null,
  },
  creditRecord: {
    applicant1: {
      adverseCreditDetails: null,
      bankruptcyAmount: null,
      bankruptcyLatestDate: null,
      ccjAmount: null,
      ccjLatestDate: null,
      criminalConvictionsDetails: null,
      defaultAmount: null,
      defaultLatestDate: null,
      hasAdverseCredit: null,
      hasCriminalConvictions: null,
      mortgageArrearsAmount: null,
      mortgageArrearsLatestDate: null,
    },
    applicant2: null,
    delphiScore: null,
  },
  expenditure: {
    applicant1: {
      balance: {
        remaining: null,
        toBeCleared: null,
        total: null,
      },
      monthly: {
        remaining: null,
        toBeCleared: null,
        total: null,
      },
    },
    applicant2: null,
    combinedMonthlyBasicSpend: null,
  },
  income: {
    current: {
      applicant1: {
        employmentIncome: null,
        otherIncome: null,
        pensionIncome: null,
        selfEmploymentIncome: null,
        totalIncome: null,
      },
      applicant2: null,
      combined: null,
    },
    future: {
      applicant1: {
        employmentIncome: null,
        otherIncome: null,
        pensionIncome: null,
        selfEmploymentIncome: null,
        totalIncome: null,
      },
      applicant2: null,
      combined: null,
    },
    survivor: {
      applicant1: {
        survivorIncome: null,
      },
      applicant2: null,
    },
  },
  loan: {
    productType: 'UNKNOWN',
    assistingOthers: null,
    debtConsolidation: null,
    debtToIncome: null,
    discretionarySpend: null,
    fixedInterestRate: null,
    grossLoan: null,
    netLoan: null,
    homeImprovements: null,
    loanPurchase: null,
    loanPurpose: null,
    loanRemortgage: null,
    loanToValue: null,
    otherPurposes: null,
    productName: null,
    productTermLength: null,
  },
  mortgageProperty: {
    city: null,
    flatNumber: null,
    buildingNumber: null,
    buildingName: null,
    street: null,
    postcode: null,
    region: null,
    remainingLeaseYears: null,
    tenure: null,
    type: null,
    valuationConfirmedValue: null,
    valuationEstimatedValue: null,
    valuationInspectionDate: null,
    valuationType: null,
  },
  specialConditions: {
    specialConditions: null,
  },
  summary: {
    applicationDate: null,
    applicationId: null,
    applicantSurname: null,
    creditPolicyExemptionRationale: null,
    delegatedAuthorityLevel: null,
    firmName: null,
    hasAdverseCredit: null,
    isCreditPolicyExemption: null,
    underwriter: null,
    underwriterRecommendation: null,
  },
  repaymentStrategy: {
    haveEndownments: null,
    haveInvestments: null,
    haveOther: null,
    haveSaleOfAnotherProperty: null,
    haveSaleOfPropertyAndDownsizing: null,
  },
};

export default data;
